export const LICENSES_WITH_MOST_SHIFTS = ["CNA", "LVN", "RN", "CAREGIVER"];
